import { SET_LANGUAGES } from '../mutation-types'
import helperApi from '../../api/HelperApi'

const state = {
  languages: []
}

const getters = {
  languagesList: state => state.languages
}

const actions = {
  async setLanguages ({ state, commit }) {
    if (state.languages.length) return

    try {
      const languages = await helperApi.getLanguages()
      commit(SET_LANGUAGES, languages)
      return languages
    } catch (e) {
      return e
    }
  }
}

const mutations = {
  [SET_LANGUAGES] (state, languages) {
    state.languages = languages
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
